import React, { useState } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Grid, Typography } from "@mui/material";

import * as styles from "./expandable.css";

interface ExpandableProps {
  title: string;
  text: string;
}

export const Expandable = ({ title, text }: ExpandableProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.wrapper}>
      <div
        onClick={() => {
          setOpen(!open);
        }}
        className={styles.mainSectionWrapperStyle}
      >
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          wrap="nowrap"
        >
          <Typography className={styles.titleStyle}>{title}</Typography>
          <KeyboardArrowDownIcon className={styles.arrow({ open })} />
        </Grid>
      </div>
      <div className={styles.collapsibleWrapperStyle({ open })}>
        <Typography className={styles.textStyle}>{text}</Typography>
      </div>
    </div>
  );
};
